// FullLayout.js - Updated with responsive sidebar state
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Container } from "reactstrap";
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const FullLayout = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hide = queryParams.get('hide') === 'true';

  // Add sidebar state management
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  // Handle resize to detect mobile/desktop
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      
      // On desktop, always show sidebar
      if (!mobile) {
        setSidebarOpen(false);
        // Remove mobile classes if any
        document.getElementById("sidebarArea")?.classList.remove("showSidebar");
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-hide sidebar when route changes on mobile
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
      document.getElementById("sidebarArea")?.classList.remove("showSidebar");
    }
  }, [location.pathname, isMobile]);

  // Functions to pass to Header and Sidebar
  const handleSidebarToggle = () => {
    if (isMobile) {
      setSidebarOpen(!sidebarOpen);
      document.getElementById("sidebarArea")?.classList.toggle("showSidebar");
    }
  };

  const handleNavClick = () => {
    if (isMobile) {
      setSidebarOpen(false);
      document.getElementById("sidebarArea")?.classList.remove("showSidebar");
    }
  };

  useEffect(() => {
    const hasReloaded = sessionStorage.getItem('hasReloaded');

    if (!hasReloaded) {
      sessionStorage.setItem('hasReloaded', 'true');
      window.location.reload();
    }
  }, []);

  return (
    <main>
      <div className="pageWrapper d-lg-flex">
        {/********Sidebar**********/}
        <aside className="sidebarArea shadow" id="sidebarArea" style={{ zIndex: '10' }}>
          {!hide && (
            <Sidebar 
              onNavClick={handleNavClick}
              isMobile={isMobile}
              isOpen={sidebarOpen}
            />
          )}
        </aside>
        {/********Content Area**********/}
        <div className="contentArea bg-white">
          {/********header**********/}
          <Header onToggleSidebar={handleSidebarToggle} />
          {/********Middle Content**********/}
          <Container className="p-1 wrapper" fluid>
            <Outlet />
          </Container>
        </div>
      </div>
    </main>
  );
};

export default FullLayout;